import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Edit = () => {
    return (
        <>
            <Header as="h1" id="edit-header">Edit</Header>
        </>
    );
};

export default Edit;